module.exports = __webpack_public_path__ + "static/media/swaziland.efca0e37.svg";